/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_Upload_FailedInputs */

const en_us2_coach_mic_upload_failed = /** @type {(inputs: Coach_Mic_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The recording could not be sent. Check your connection.`)
};

const pt_br2_coach_mic_upload_failed = /** @type {(inputs: Coach_Mic_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para enviar o áudio. Confira a conexão.`)
};

const es_419_coach_mic_upload_failed = /** @type {(inputs: Coach_Mic_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar el audio. Revisa tu conexión.`)
};

const pt_pt2_coach_mic_upload_failed = /** @type {(inputs: Coach_Mic_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar o áudio. Verifica a ligação.`)
};

const fr_fr2_coach_mic_upload_failed = /** @type {(inputs: Coach_Mic_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'envoyer l'enregistrement. Vérifie ta connexion.`)
};

const de_de2_coach_mic_upload_failed = /** @type {(inputs: Coach_Mic_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aufnahme konnte nicht gesendet werden. Prüfe deine Verbindung.`)
};

const it_it2_coach_mic_upload_failed = /** @type {(inputs: Coach_Mic_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile inviare la registrazione. Controlla la connessione.`)
};

/**
* | output |
* | --- |
* | "The recording could not be sent. Check your connection." |
*
* @param {Coach_Mic_Upload_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_upload_failed = /** @type {((inputs?: Coach_Mic_Upload_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_Upload_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_upload_failed(inputs)
	if (locale === "es-419") return es_419_coach_mic_upload_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_upload_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_upload_failed(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_upload_failed(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_upload_failed(inputs)
	return en_us2_coach_mic_upload_failed(inputs)
});
export { coach_mic_upload_failed as "coach-mic.upload_failed" }